export default class SideBarActions {
  static TOGGLE = "TOGGLE";
  static CLOSE = "CLOSE";
}
